import React from "react";
import moment from "moment";
import "./unassignedWeekStrip.scss";

export type UnassignedWeekStripDay = {
  dateKey: string;
  weekdayShort: string;
  dayOfMonth: number;
  count: number;
};

export interface UnassignedWeekStripProps {
  days: Array<UnassignedWeekStripDay>;
  selectedDateKey: string;
  onSelectDateKey: (dateKey: string) => void;
}

type PickupCountsByDay = { [k: string]: number };

export function buildUnassignedWeekStripDays(
  countsByDateKey: PickupCountsByDay
): Array<UnassignedWeekStripDay> {
  const start = moment().startOf("week");
  return Array.from({ length: 7 }, (_, i) => {
    const d = start.clone().add(i, "day");
    const dateKey = d.format("YYYY-MM-DD");
    return {
      dateKey,
      weekdayShort: d.format("ddd"),
      dayOfMonth: d.date(),
      count: countsByDateKey[dateKey] ?? 0,
    };
  });
}

export function UnassignedWeekStrip({
  days,
  selectedDateKey,
  onSelectDateKey,
}: UnassignedWeekStripProps): JSX.Element {
  const todayKey = moment().format("YYYY-MM-DD");

  return (
    <div className="xgs-unassigned-week-strip" role="listbox" aria-label="Pickup date">
      {days.map((d) => {
        const selected = d.dateKey === selectedDateKey;
        const isToday = d.dateKey === todayKey;
        return (
          <button
            key={d.dateKey}
            type="button"
            role="option"
            aria-selected={selected}
            className={
              "xgs-unassigned-week-strip__day" +
              (selected ? " xgs-unassigned-week-strip__day--selected" : "") +
              (isToday ? " xgs-unassigned-week-strip__day--today" : "")
            }
            onClick={() => onSelectDateKey(d.dateKey)}
          >
            <span className="xgs-unassigned-week-strip__weekday">{d.weekdayShort}</span>
            <span className="xgs-unassigned-week-strip__date">{d.dayOfMonth}</span>
            <span className="xgs-unassigned-week-strip__count">{d.count}</span>
          </button>
        );
      })}
    </div>
  );
}
